class CartDrawerFlyout extends HTMLElement {
  constructor() {
    super();
    this.flyOut = this.querySelector('fly-out');
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    // Programmatically open the flyout after rendering
    setTimeout(() => {
      if (this.flyOut) {
        this.flyOut.open(); 
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer-flyout')) {
  customElements.define('cart-drawer-flyout', CartDrawerFlyout);
}
